import {
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  createPaymentLink,
  fetchPaymentLinks,
} from '../../services/PaymentLinkService';
import { PaginatedData, PaginationConfig } from '../../types/common';
import { NewApiError } from '../../types/NewApiError';
import { PaymentLink, PaymentLinkFormValues } from '../../types/PaymentLink';
import {
  queryKeyFactory,
  useMutationWithInvalidation,
} from '../../utils/queryUtils';

export const paymentLinkQueryKeys = queryKeyFactory('paymentLink');

export function usePaymentLinks(
  params: PaginationConfig
): UseQueryResult<PaginatedData<PaymentLink>, NewApiError> {
  return useQuery({
    queryKey: paymentLinkQueryKeys.list(params),
    queryFn: () => fetchPaymentLinks(params),
    enabled: !!params.page,
    keepPreviousData: true,
  });
}

export function useCreatePaymentLink(): UseMutationResult<
  PaymentLink,
  NewApiError,
  PaymentLinkFormValues,
  unknown
> {
  return useMutationWithInvalidation(
    createPaymentLink,
    paymentLinkQueryKeys.all
  );
}
